module.exports = __webpack_public_path__ + "img/8.a9b81bf7.webp";